import React, { useEffect, useState } from 'react';
import { Logo } from './Logo';
import { formatEuro } from '../utils/pricing';
const SECTIONS = [{
  id: 'opportunity',
  label: 'Opportunity'
}, {
  id: 'approach',
  label: 'Approach'
}, {
  id: 'scope',
  label: 'Scope'
}, {
  id: 'investment',
  label: 'Investment'
}, {
  id: 'next-steps',
  label: 'Next steps'
}];
interface QuotationNavProps {
  total: number;
}
export function QuotationNav({
  total
}: QuotationNavProps) {
  const [active, setActive] = useState<string>('opportunity');
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, {
      rootMargin: '-45% 0px -50% 0px'
    });
    SECTIONS.forEach(({
      id
    }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  return <header className="sticky top-0 z-50 w-full border-b border-line bg-white/90 backdrop-blur-md" data-id="element-155" data-mp="2i5oeqo2qw49f">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-156" data-mp="3t5jap2xgwwcb">
        <a href="#top" className="flex shrink-0 items-center gap-3" data-id="element-157" data-mp="3oadqc8jprpqc">
          <Logo height={26} alt="Snakker" data-id="element-158" data-mp="61d1bzzcii4z" />
          <span className="hidden text-sm font-medium text-ink-300 sm:inline" data-id="element-159" data-mp="212xotz103ta">
            × Leo Pharma
          </span>
        </a>

        <nav aria-label="Quotation sections" className="hidden lg:block" data-id="element-160" data-mp="3ag32dtfjjzlc">
          <ul className="flex items-center gap-1" data-id="element-161" data-mp="35i1oro0vwsh9">
            {SECTIONS.map(section => <li key={section.id} data-id="element-162" data-mp="3j8y1e5ef0z2o">
                <a href={`#${section.id}`} aria-current={active === section.id ? 'true' : undefined} className={`rounded-full px-3 py-1.5 text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${active === section.id ? 'bg-surface font-medium text-ink-900' : 'text-ink-500 hover:text-ink-900'}`} data-id="element-163" data-mp="3ja808wt3ebad">
                  {section.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <a href="#investment" className="flex shrink-0 items-center gap-2 rounded-full border border-line bg-white px-4 py-2 transition-colors hover:border-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-164" data-mp="zhs8g0sjo2mq">
          <span className="hidden text-[11px] uppercase tracking-widest text-ink-300 sm:inline" data-id="element-165" data-mp="bqmr1h6yh2ab">
            Year one
          </span>
          <span className="font-display text-sm font-semibold text-ink-900" data-id="element-166" data-mp="gp6gvsoo6y7y">
            {formatEuro(total)}
          </span>
        </a>
      </div>
    </header>;
}